
export let imgList = [


]
export let imgList1 = "@/assets/img/list/1.jpg"
export let imgList2 = "@/assets/img/list/2.jpg"
export let imgList3 = "@/assets/img/list/3.jpg"
export let imgList4 = "@/assets/img/list/4.jpg"
export let imgList5 = "@/assets/img/list/5.jpg"
export let imgList6 = "@/assets/img/list/6.jpg"
export let imgList7 = "@/assets/img/list/7.jpg"


export let imgsrc = '@/assets/img/carousel/1 (1).jpg'

export let carouselList = [
    {
        id: 1,
        img: '@/assets/img/carousel/1 (1).jpg',
        text: ''
    },
    {
        id: 2,
        img: './assets/img/carousel/1 (2).jpg',
        text: ''
    },
    {
        id: 3,
        img: './assets/img/carousel/1 (3).jpg',
        text: ''
    },
    // {
    //     id: 4,
    //     img: './assets/img/carousel/1 (4).jpg',
    //     text: ''
    // },
    // {
    //     id: 5,
    //     img: './assets/img/carousel/1 (5).jpg',
    //     text: ''
    // },
    // {
    //     id: 6,
    //     img: './assets/img/carousel/1 (6).jpg',
    //     text: ''
    // },
]
export let textList = [
    {
        id: 2,
        title: 'The Kia PV5 Cargo',
        text: "The PV5 Cargo is a ground of smart business solutions. Particularly optimized for business purposes, it equips a maximum cargo space of 5,165L, a 423mm cargo room step height, up to 1,815mm of interior height. It also provides business-optimized software such as FMS (Fleet Management Solutions) with Geotab partnership. This will enable fleet customers to connect to their business wherever using high-quality vehicle data without additional devices or services."
    },
    {
        id: 1,
        title: 'The Kia PV5 Passenger',
        text: 'The PV5 Passenger is a ground of best flexible EV. It has not only a spacious interior with 5/6/7 seater variations, but also has features like a wide display (7.5" cluster + 12.9" IVI system), Digital Key 2.0, and best-in-class ADAS specifications. AAOS (Android Automotive Operating System)-based IVI (In-Vehicle Infotainment) system, App market and OTA (Over-the-Air) updates ensure that customers can enjoy a cutting-edge vehicle experience. This seamless integration of personal and business needs makes itself a truly multi-purpose solution.'
        // text: 'The PV5 Passenger is a ground of best flexible EV. ive Operati-the-Air) updates ensure that customers can enjoy a cutting-edge vehicle experience. This seamless integration of personal and business needs makes itself a truly multi-purpose solution.'
    },
    {
        id: 3,
        title: 'The Kia PV5 WAV (Wheelchair Accessible Vehicle)',
        text: 'The Kia PV5 WAV is a ground of waive-less life. Thoughtfully developed for all passengers, companions, and drivers. To ensure that general passengers and wheelchair users can safely board the vehicle, a ‘side entry’ feature with a wheelchair ramp system is implemented. Additionally, a universal belt fastening system and the second-row seating access provide the same comfort and stability as general passengers, allowing accompanying passengers to assist the wheelchair users from the side. The Kia PV5 WAV offers enhanced freedom of movement.'
    },
    {
        id: 4,
        title: 'The Kia PV5 Crew',
        text: "The PV5 Crew is a ground of best credible conversion. Based on Kia's conversion business system, the 2nd-row space can be freely transformed into a cargo room according to needs. With three L-Track mounting system securing irregular-shaped cargo and in-room V2L, it enhances the versatility between cargo and passenger. Kia directly manufactures and guarantees all these conversion specifications, ensuring high-quality vehicle production and comprehensive support."
    },

]